function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "stove_with_gril"
}, /*#__PURE__*/React.createElement("title", null, "190808_VF_Nina_App_Icons_RZ"), /*#__PURE__*/React.createElement("path", {
  d: "M14.2.1l.5 133.8-.5 149.6h255.1V0L14.2.1zm226.7 28.2V85H42.5V28.3h198.4zM42.5 255.1V99.2h198.4v155.9H42.5z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "177.1",
  cy: "57.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "212.6",
  cy: "57.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "141.7",
  cy: "57.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "106.3",
  cy: "57.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "70.8",
  cy: "57.1",
  r: "14.2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M206 204.8c-5.2-6.2-13-12.6-22.1-17.8-8.9-5.1-18-8.7-25.9-10.1 2.8-7.9 4.2-17.7 4.2-27.3 0-20.8-6.5-43.3-20.7-43.3s-20.7 22.4-20.7 43.3c0 9.6 1.4 19.6 4.3 27.5-7.8 1.5-16.9 5-25.6 10-9.1 5.2-16.9 11.6-22.1 17.8-9 10.9-7.1 18.3-5.1 21.7 1.6 2.8 5.6 7 14.9 7 2.2 0 4.3-.2 6.4-.6 8-1.3 17.4-5 26.4-10.2 8.8-5.1 16.5-11.2 21.6-17.3 5.2 6 12.7 12.1 21.5 17.1 9.1 5.2 18.4 8.9 26.4 10.2 2.1.4 4.3.6 6.4.6 9.3 0 13.3-4.2 14.9-7 2.3-3.3 4.2-10.7-4.8-21.6zm-64.5-83.4c2.3 2.8 6.2 12.5 6.2 28.2s-3.9 25.3-6.2 28.2c-2.3-2.8-6.2-12.5-6.2-28.2s3.9-25.3 6.2-28.2zm-28.6 89c-13.6 7.8-23.9 9.3-27.5 8.8 1.3-3.4 7.8-11.6 21.3-19.4 13.6-7.8 23.9-9.3 27.5-8.8-1.2 3.4-7.7 11.6-21.3 19.4zm57.6-.2c-13.6-7.8-20-16-21.3-19.4 3.6-.6 13.9.9 27.5 8.8 13.6 7.8 20 16 21.3 19.4-3.6.5-13.9-1-27.5-8.8z"
}))));